/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReorderPortfoliosDto
 */
export interface ReorderPortfoliosDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ReorderPortfoliosDto
     */
    portfolioIds: Array<string>;
}

export function ReorderPortfoliosDtoFromJSON(json: any): ReorderPortfoliosDto {
    return ReorderPortfoliosDtoFromJSONTyped(json, false);
}

export function ReorderPortfoliosDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReorderPortfoliosDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'portfolioIds': json['portfolioIds'],
    };
}

export function ReorderPortfoliosDtoToJSON(value?: ReorderPortfoliosDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'portfolioIds': value.portfolioIds,
    };
}

